import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

interface UseFetchWeeksListParams {
  limit?: number;
}

export const useFetchWeeksList = (params?: UseFetchWeeksListParams) => {
  const { limit = 10 } = params || {};

  const queryFn = async ({ pageParam = 1 }) => {
    const response = await fetchClient.GET("/nft/weeks", {
      params: {
        query: {
          page: typeof pageParam === "number" ? pageParam : 1,
          limit,
        },
      },
    });
    const error = response.error;
    if (error) throw error;
    return response.data;
  };

  const {
    data,
    error,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isFetchNextPageError,
  } = useInfiniteQuery({
    queryKey: ["user", "weeks-list", limit],
    queryFn,
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const pagination = lastPage?.data?.pagination;

      if (pagination?.hasNextPage) return pagination.page + 1;

      return undefined;
    },
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchInterval: false,
    refetchIntervalInBackground: false,
  });

  return {
    data,
    error,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isFetchNextPageError,
  };
};
